import { asRecordId, composeQuery } from './queries'
import { getUserId } from './users'

export const whereActive = (query) => query.where('active', '==', true)

export const limit =
  (limitValue = 1) =>
    (query) =>
      query.limit(limitValue)

export const doc = (id) => (query) => query.doc(id)

export const add = (data) => (query) => query.add(data)

export const collection = (name) => (query) => query.collection(name)

export const orderBy =
  (field, direction = 'asc') =>
    (query) =>
      query.orderBy(field, direction)

export const READ_ACCESS = 'read'
export const WRITE_ACCESS = 'write'

export const toUserAccess = (user) => `user:${getUserId(user)}`
export const toAccountAccess = (account) => `account:${asRecordId(account)}`

export const canAccess = (
  accessType,
  { access: { [accessType]: existingAccess } },
  { user, account: { id: accountId }, isAccountAdmin }
) => {
  const requestedAccess = [toUserAccess(user)]
  if (isAccountAdmin) {
    requestedAccess.push(toAccountAccess(accountId))
  }
  return requestedAccess.some((access) => existingAccess.includes(access))
}

export const whereAccessExists =
  (accessType, ...accessValues) =>
    (query) =>
      query.where(`access.${accessType}`, 'array-contains-any', accessValues)

export const listReadableForUser =
  (collection, ...conditions) =>
    (user) => {
      return composeQuery(
        collection,
        whereAccessExists(READ_ACCESS, toUserAccess(user)),
        ...conditions
      )
    }

export const listReadableForAccountAndUser =
  (collection, ...conditions) =>
    (account, user) =>
      composeQuery(
        collection,
        ...conditions,
        whereAccessExists(
          READ_ACCESS,
          toAccountAccess(account),
          toUserAccess(user)
        )
      )

export const listReadableForAccount =
  (collection, ...conditions) =>
    (account) =>
      composeQuery(
        collection,
        ...conditions,
        whereAccessExists(READ_ACCESS, toAccountAccess(account))
      )
